// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__hcg-k","modalContainer":"Modal_modalContainer__y8MBA","modal":"Modal_modal__ALWqE","slide-down":"Modal_slide-down__B84s-"};